import React, { useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { headApi } from "utils/headApi";
import { imgApi } from "utils/imgApi";
import { BiEdit } from "react-icons/bi";
import MenuItem from "@material-ui/core/MenuItem";
import Check from "@material-ui/icons/Check";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import CardIcon from "components/Card/CardIcon.js";
import styles from "assets/jss/material-dashboard-pro-react/views/userProfileStyles.js";
import style from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.js";
import { localApi } from "utils/imgApi";
import styleCheck from "assets/jss/material-dashboard-pro-react/views/registerPageStyle";
import styleSweet from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.js";
import SweetAlert from "react-bootstrap-sweetalert";

const useStyles = makeStyles(styles);
const useStyle = makeStyles(style);
const useStyleCheck = makeStyles(styleCheck);
const useStyleSweet = makeStyles(styleSweet);

export default function UpdateSet(props) {
  const [items, setItems] = React.useState([]);
  const [simpleSelect, setSimpleSelect] = React.useState("");
  const [descName, setDescName] = React.useState("");
  const [pcs, setPcs] = React.useState("");
  const [descErr, setDescErr] = React.useState("");
  const [pcsErr, setPcsErr] = React.useState("");
  const [getId, setGetId] = React.useState("");
  const [active, setActive] = React.useState(false);
  const [submitted, setSubmitted] = React.useState(false);
  const [alertType, alertTypeOps] = React.useState("");
  const [alertMsg, alertMsgOps] = React.useState("");
  const [btn, setBtn] = React.useState(false);

  const classes = useStyles();
  const classe = useStyle();
  const classCheck = useStyleCheck();
  const classSweet = useStyleSweet();

  const userObj = JSON.parse(sessionStorage.getItem("sessionData"));

  async function getSets() {
    const api = localApi + `/sets/list/byAdminId/${userObj && userObj.id}`;
    const result = await fetch(api);
    const getResult = await result.json();
    setItems(getResult && getResult);
    // console.log(getResult);
  }

  useEffect(() => {
    getSets();
  }, []);

  const handleSimple = (event) => {
    // setSimpleSelect(event.target.value);
    const { value } = event.target;
    const item = items.find((item) => item.id == value);
    setSimpleSelect(value);
    setDescName(item.setDesc);
    setPcs(item.pcs);
    setActive(item.active);
    setGetId(item.id);
    // setGetId(item.id);
  };

  const SubmitUpdateSets = async (e) => {
    let errorCount = 0;
    if (descName === "" || !descName) {
      errorCount++;
      setDescErr("Description Name is Required");
    }

    if (pcs === "" || !pcs) {
      errorCount++;
      setPcsErr("Piece/Sets is Required");
    }

    if (errorCount === 0) {
      setBtn(true);
      const requestOptions = {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          adminId: userObj.id,
          setDesc: descName,
          pcs: pcs,
        }),
      };

      fetch(localApi + `/sets/update/SetsById/${getId}`, requestOptions)
        .then((response) => response.json())
        .then((data) => {
          // console.log(data);
          if (data.message === "Data Updated Successfully !!!") {
            alertTypeOps("success");
            alertMsgOps("Succesfully !!!");
            setSubmitted(true);
          }
        });
    }
  };

  const hideAlert = () => {
    setSubmitted(false);
    window.location.reload(false);
  };

  return (
    <div>
      <GridContainer justify="center" alignItems="center">
        <GridItem xs={12} sm={6} md={6}>
          <Card>
            <CardHeader color="rose" icon>
              <CardIcon color="rose">
                <BiEdit />
              </CardIcon>
              <h3 className={classes.cardIconTitle}>
                <small>Update Piece/Sets</small>
              </h3>
            </CardHeader>
            <CardBody>
              <GridContainer>
                {submitted ? (
                  <SweetAlert
                    type={alertType}
                    style={{ display: "block", marginTop: "-100px" }}
                    title={alertMsg}
                    onConfirm={() => hideAlert()}
                    confirmBtnCssClass={
                      classSweet.button + " " + classSweet.success
                    }
                  >Updated Sets</SweetAlert>
                ) : null}{" "}
                <GridItem xs={12} sm={12} md={12}>
                  <FormControl fullWidth className={classe.selectFormControl}>
                    <InputLabel
                      htmlFor="simple-select"
                      className={classe.selectLabel}
                    >
                      Select Piece/Sets
                    </InputLabel>

                    <Select
                      MenuProps={{
                        className: classe.selectMenu,
                      }}
                      classes={{
                        select: classe.select,
                      }}
                      value={simpleSelect}
                      onChange={handleSimple}
                      inputProps={{
                        name: "simpleSelect",
                        id: "simple-select",
                      }}
                    >
                      <MenuItem
                        disabled
                        classes={{
                          root: classe.selectMenuItem,
                        }}
                      >
                        Select Piece/Sets
                      </MenuItem>
                      {items &&
                        items.map((item) => (
                          <MenuItem
                            key={item.id}
                            value={item.id}
                            classes={{
                              root: classe.selectMenuItem,
                              selected: classe.selectMenuItemSelected,
                            }}
                          >
                            {item.setDesc}
                          </MenuItem>
                        ))}
                    </Select>
                  </FormControl>
                </GridItem>
                <GridItem xs={12} sm={6} md={6}>
                  <CustomInput
                    labelText="Description Name..."
                    id="descName"
                    inputProps={{
                      placeholder: "Eg: 2 Pcs in 1 Set...",
                    }}
                    formControlProps={{
                      fullWidth: true,
                    }}
                    name="descName"
                    value={descName}
                    onChange={(e) => {
                      setDescName(e.target.value);
                      setDescErr("");
                    }}
                    required={true}
                  />
                  <span style={{ color: "red" }}>{descErr}</span>
                </GridItem>
                <GridItem xs={12} sm={6} md={6}>
                  <CustomInput
                    labelText="Piece/set..."
                    id="psc"
                    inputProps={{
                      placeholder: "Piece/set...",
                    }}
                    formControlProps={{
                      fullWidth: true,
                    }}
                    name="pcs"
                    value={pcs}
                    onChange={(e) => {
                      setPcs(e.target.value);
                      setPcsErr("");
                    }}
                    required={true}
                  />
                  <span style={{ color: "red" }}>{pcsErr}</span>
                </GridItem>
              </GridContainer>
              {/* <Button
                color="rose"
                onClick={SubmitUpdateSets}
                className={classes.updateProfileButton}
              >
                Update
              </Button> */}
              {btn === true ? (
                <Button className={classes.updateProfileButton}>Update</Button>
              ) : (
                <Button
                  color="rose"
                  onClick={SubmitUpdateSets}
                  className={classes.updateProfileButton}
                >
                  Update
                </Button>
              )}
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    </div>
  );
}
